/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { deprecationsEntryPoint } from '@jira/itam__ham-settings-hardware-deprecations/src/deprecationsEntryPoint.entrypoint.tsx';
import { stockRulesEntryPoint } from '@jira/itam__ham-settings-hardware-stock-rules/src/stockRulesEntryPoint.entrypoint.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { HardwareSettingsEntrypointProps } from './HardwareSettings.entrypoint.types.tsx';
import type { HardwareSettingsTypes } from './hardwareSettingsTypes.tsx';

const DEFAULT_TAB = 'deprecations';

const TAB_ENTRYPOINT_MAP: Record<
	string,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, { entryPoint: EntryPoint<any, any>; entryPointParams: Record<string, never> }>
> = {
	hardware: {},
	deprecations: {
		deprecationsEntryPoint: {
			entryPoint: deprecationsEntryPoint,
			entryPointParams: {},
		},
	},
	'stock-rules': {
		stockRulesEntryPoint: {
			entryPoint: stockRulesEntryPoint,
			entryPointParams: {},
		},
	},
};

type HardwareSettingsEntryPointComponent = EntryPointComponent<
	{},
	HardwareSettingsTypes,
	HardwareSettingsEntrypointProps,
	{}
>;

export const hardwareSettingsEntryPoint: EntryPoint<
	HardwareSettingsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<HardwareSettingsEntryPointComponent>(
		/* webpackChunkName: "async-itam-settings-hardware" */ './HardwareSettings.tsx',
	),
	getPreloadProps: (params: EntryPointRouteParams) => {
		const tab = params?.context?.query?.tab ?? DEFAULT_TAB;
		const activeTab = tab in TAB_ENTRYPOINT_MAP ? tab : DEFAULT_TAB;

		return {
			entryPoints: TAB_ENTRYPOINT_MAP[activeTab],
		};
	},
});
